import type {AccountFacts} from '@/lib/forex-display-api';
const versions={current:'当前发布版本',outdated:'待升级',pending:'等待新版确认',unknown:'版本待确认'};
const upgrades:Record<string,string>={awaiting_discovery:'正在识别品种',awaiting_config_ack:'等待配置确认',completed:'能力配置已确认',blocked:'升级受阻',rolled_back:'已恢复原版本'};
export default function AccountSymbolStatus({facts}:{facts:AccountFacts}){
 const support=facts.symbol_support,release=facts.release_alignment,upgrade=facts.symbol_upgrade;
 return <div className="space-y-1 text-xs text-text-muted" aria-label="账号版本与品种能力">
  <p>{release?versions[release.status]:'版本待确认'}{release?.current_template_id&&` · ${release.current_template_id}`}</p>
  {release?.target_template_id&&release.target_template_id!==release.current_template_id&&<p>目标版本：{release.target_template_id}</p>}
  <p>{support?.status==='ready'?`支持 ${support.supported_symbols.join('、')}`:'品种能力待验证'}</p>
  {!!support?.unresolved_symbols.length&&<p>待确认：{support.unresolved_symbols.join('、')}</p>}
  {upgrade&&<p>{upgrades[upgrade.state]||'升级状态待确认'}{upgrade.reason_code&&` · ${upgrade.reason_code}`}</p>}
 </div>;
}
